import { render, staticRenderFns } from "./SwitchBatchDrawer.vue?vue&type=template&id=f0f146a4&scoped=true"
import script from "./SwitchBatchDrawer.vue?vue&type=script&lang=js"
export * from "./SwitchBatchDrawer.vue?vue&type=script&lang=js"
import style0 from "./SwitchBatchDrawer.vue?vue&type=style&index=0&id=f0f146a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f146a4",
  null
  
)

export default component.exports